import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import * as XLSX from 'xlsx';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Restock } from '../../../common/model/restock-report.interface';
import { RestockReportService } from '../../../common/facade/restock-report.service';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { Organization } from '../../../common/model/Organization';


// for excel import
type AOA = any[][];

@Component({
    selector: 'app-restock-report',
    templateUrl: './restock-report.component.html',
    styleUrls: ['./restock-report.component.css']
})
export class RestockReportComponent implements OnInit {

    public res = res;
    titleImport = res.Import;
    lblExport = res.Export;
    lblStyle = res.Style;
    lblVariety = res.Variety;
    lblSize = res.Size;
    lblStatus = res.Status;
    lblFecha = res.Date;
    lblStore = res.Store;
    lblStartDate = res.StartDate;
    lblEndDate = res.EndDate;
    lblRestock = res.Restock
    lblStrategyCR = res.CR;
    lblStrategyNB = res.NB;
    lblStrategyRTC = res.RTC;

    @ViewChild('modal') public modal: ModalDirective;
    rd: string = '';
    bl: boolean = false;

    lblImportFile = res.ImportFile;
    lblChoose = res.Choose;
    lblSelectAFile = res.SelectAFile;
    lblCancel = res.Cancel;
    lblContinueSaving = res.ContinueSaving;

    lblRestockReport = res.RestockReport;
    lblRestockChampions = res.RestockChampions;
    lblReinforceCentralSizes = res.ReinforceCentralSizes;
    lblNB = res.NewBasics;
    lblRestockSave = res.RestockSave;
    lblSave = res.Save;
    lblSearch = res.Search;
    lblStock = res.Stock
    lblSell = res.Sell;
    lblSelectAnOption = res.SelectAnOption;

    isSpanish = true;
    language = 0;

    loading = false;
    messageLoader = '';

    messagesTable: any = {
        emptyMessage: '',
        totalMessage: ''
    };

    rows: Restock[] = [];

    // alert
    alertsFileExcel = [];
    generalAlerts = [];

    // import excel
    excelData: AOA = [[], []];
    wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
    fileName = 'SheetJS.xlsx';
    excelRows: Restock[];

    lsStore: any[] = [];
    public catStoreId = -1;

    public txtMinDate = new Date(this.getNowUTC().getFullYear() - 1,
        this.getNowUTC().getMonth(),
        1,
        this.getNowUTC().getHours(),
        this.getNowUTC().getMinutes(),
        this.getNowUTC().getSeconds(),
        this.getNowUTC().getMilliseconds());
    public txtMaxDate = new Date();
    public txtStartDate = new Date();
    public txtEndDate = new Date();

    lstOrganization: Organization[] = [];
    availableOrganizations: Organization[] = [];
    selectedOrganizations: Organization[] = [];
    public organizationSelected: any[] = [];
    strOrganizationSelected: string;
    tenantId: number;

    constructor(
        @Inject(SESSION_STORAGE) private _storage: WebStorageService,
        public strings: Strings,
        private _restockTeportService: RestockReportService,
        private _storeFacade: StoreFacade,
        private _excel: ExcelUtility,
        private _datePipe: DatePipe,
        private _router: Router,
        private localeService: BsLocaleService
    ) {
        this._storage.set('moduleUrl', this._router.url);
    }

    ngOnInit() {
        this.isSpanish = this.strings.getLanguageIsSpanish();
        this.localeService.use(this.strings.getLanguage());

        this.availableOrganizations = this.strings.getAvailableOrganizations();
        this.tenantId = this.strings.getTenant();
        this.lstOrganization = this.availableOrganizations.filter(item => item.tenantId == this.tenantId);

        this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
        this.messagesTable.totalMessage = 'Total';

        if (!this.isSpanish) {
            this.language = 1;
        }

        this.onChangeRBT();
    }

    downloadLayout() {
        if (this.rows.length > 0) {
            const data: any = [];
            this.rows.forEach(row => {
                let info: any;

                switch (this.rd) {
                    case Strategy.CAMPEONES_RESURTIBLES:
                    case Strategy.NUEVOS_BASICOS:
                        info = {
                            [this.strings.GetText(res.Style)]: row.style,
                            [this.strings.GetText(res.Variety)]: row.variety,
                            [this.strings.GetText(res.Stock)]: row.stock,
                            [this.strings.GetText(res.Sell)]: row.sell,
                            [this.strings.GetText(res.Date)]: row.date
                        };
                        break;
                    case Strategy.REFUERZO_TALLAS_CENTRALES:
                        info = {
                            [this.strings.GetText(res.Style)]: row.style,
                            [this.strings.GetText(res.Variety)]: row.variety,
                            [this.strings.GetText(res.Size)]: row.sizes,
                            [this.strings.GetText(res.Stock)]: row.stock,
                            [this.strings.GetText(res.Sell)]: row.sell,
                            [this.strings.GetText(res.Date)]: row.date
                        };
                        break;
                }
                data.push(info);
            });
            this._excel.exportAsExcelFile(data, 'Report_Strategy_' + this.rd.toUpperCase());
        } else {
            this.addAlert('<strong>' + this.strings.GetText(res.ThereIsNoInformation) + '</strong>', 'danger', 'excel');
        }
    }



    // añadir alert
    addAlert(message: String, type: String, fileType: String) {
        if (fileType === 'excel') {
            this.alertsFileExcel = [];
            this.alertsFileExcel.push({
                type: type,
                msg: message
            });
        } else {
            this.generalAlerts = [];
            this.generalAlerts.push({
                type: type,
                msg: message
            });
        }

    }

    onChangeRBT() {
        this.rows = [];
        this.rd = document.querySelector('input[name="restock"]:checked')['value'];

        switch (this.rd) {
            case Strategy.CAMPEONES_RESURTIBLES:
            case Strategy.NUEVOS_BASICOS:
                this.bl = false;
                break;
            case Strategy.REFUERZO_TALLAS_CENTRALES:
                this.bl = true;
                break;
        }
    }

    onChangeStartDate(value) {
        this.txtStartDate = this.subtractTimeFromDate(value, 6);
    }

    onChangeEndDate(value) {
        this.txtEndDate = this.subtractTimeFromDate(value, 6);
    }

    GetStore() {
        this.loading = true;
        this._storeFacade.GetAssignedByStoreEmail().subscribe(
            response => {
                if (response.completed) {
                    this.lsStore = response.data.filter(store => this.strOrganizationSelected.includes(store.organizationId));
                }
                else {
                    this.addAlert('<strong>' + response.message + '</strong>', 'danger', 'general');
                }

            }, error => {
                this.loading = false;
                this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
            }
        );
        this.loading = false;
    }

    GetRestock() {

        if (this.catStoreId == -1) {
            this.addAlert('<strong>' + this.strings.GetText(res.AlertYouMustSelectTheStore) + '</strong>', 'danger', 'general');
        }
        else if(new Date(this.txtStartDate) > new Date(this.txtEndDate)) {
            this.addAlert('<strong>' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher) + '<strong>', 'danger', 'date');
        }
        else {
            this.rows = [];

            this.loading = true;
            this._restockTeportService.GetRestock(this.rd, this.catStoreId, this._datePipe.transform(this.txtStartDate, 'yyyyMMdd'), this._datePipe.transform(this.txtEndDate, 'yyyyMMdd'), this.strOrganizationSelected).subscribe(
                response => {
                    if (response.completed) {
                        this.rows = response.data;
                    }
                    else {
                        this.addAlert('<strong>' + response.message + '</strong>', 'danger', 'general');
                    }

                    this.loading = false;
                }, error => {
                    this.loading = false;
                    this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
                }
            );
        }
    }

    private getNowUTC() {
        const now = new Date();
        return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
    }

    onChangeOrganization(selectedOrganizations: any[]) {
        this.selectedOrganizations = selectedOrganizations;
        this.strOrganizationSelected = this.selectedOrganizations
            .map((e) => e.organizationId)
            .join(',');
        this.GetStore()
    }

    subtractTimeFromDate(objDate, intHours) {
        var numberOfMlSeconds = objDate.getTime();
        var addMlSeconds = intHours * 60 * 60000;
        var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
        return newDateObj;
      }
}

export const Strategy = {
    CAMPEONES_RESURTIBLES: 'cr',
    NUEVOS_BASICOS: 'nb',
    REFUERZO_TALLAS_CENTRALES: 'rtc'
}
